<template>
  <div >
    <!-- <Navbar />
    <Sidebar /> -->
    <!-- <Main v-if="client === 'Development'" /> -->
    <LowStateTypeDashboard v-if="stateType === 'Low'" />
    <MediumStateTypeDashboard v-if="stateType === 'Medium'" />
    <HighStateTypeDashboard v-if="stateType === 'High'" />
    <VersionModal ref="showVersionModal" />
  </div>
</template>

<script>
// @ is an alias to /src
import VersionModal from '@/components/VersionModal.vue'
import Sidebar from '@/components/sidebars/Sidebar.vue'
import Navbar from '@/components/Navbar.vue'
// import Main from '@/components/Main.vue'
import LowStateTypeDashboard from '@/components/dashboard/lowStateType/LowStateTypeDashboard.vue'
import HighStateTypeDashboard from '@/components/dashboard/highStateType/HighStateTypeDashboard.vue'
import MediumStateTypeDashboard from '@/components/dashboard/mediumStateType/MediumStateTypeDashboard.vue'
import { client } from '../domainConfig'

export default {
  name: 'Home',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    Sidebar,
    // eslint-disable-next-line vue/no-unused-components
    Navbar,
    LowStateTypeDashboard,
    HighStateTypeDashboard,
    // Main,
    MediumStateTypeDashboard,
    VersionModal,
  },
  data() {
    return {
      client: client.clientName,
      stateType: client.stateType,
      showVersionModal: false,
      currentVersion: null,
    }
  },
  mounted() {
    // Fetch the version when the component mounts
    this.fetchVersion();

    // Start the version check every 30 minutes
    this.startVersionCheck();
  },
  methods: {
    async openNewAppVersionPopup() {
      this.$refs.showVersionModal.show();
    },
    // eslint-disable-next-line consistent-return
    async checkVersion() {
      try {
        const res = await fetch('/version.json', { cache: 'no-store' });
        const { version } = await res.json();
        const storedVersion = localStorage.getItem('appVersion');

        if (version !== storedVersion && storedVersion !== null) {
          await this.openNewAppVersionPopup();
        }

        return version;
      } catch (error) {
        console.error('Failed to check version:', error);
      }
    },
    async fetchVersion() {
      const res = await fetch('/version.json', { cache: 'no-store' });
      const versions = await res.json();

      const storedVersion = localStorage.getItem('appVersion');
      if (!storedVersion) {
        localStorage.setItem('appVersion', versions.version);
      }
      this.currentVersion = storedVersion || versions.version;
    },
    startVersionCheck() {
      this.checkVersion();
      setInterval(this.checkVersion, 1800000); // 30 minutes in milliseconds
    },
  },
}
</script>
